import React from 'react';
import { Award, Clock, DollarSign, Package, Users, CheckCircle2 } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Award,
      title: 'Certified HVAC Technicians',
      description: 'Our team consists of highly trained and certified professionals with years of experience.'
    },
    {
      icon: Clock,
      title: 'Fast Service Response',
      description: 'Quick turnaround times with same-day service available for urgent repairs.'
    },
    {
      icon: DollarSign,
      title: 'Affordable Pricing',
      description: 'Competitive rates without compromising on quality of service or parts.'
    },
    {
      icon: Package,
      title: 'Genuine Spare Parts',
      description: 'We use only authentic spare parts from authorized dealers for all repairs.'
    },
    {
      icon: Users,
      title: 'Residential & Commercial',
      description: 'Comprehensive solutions for homes, offices, and industrial facilities.'
    },
    {
      icon: CheckCircle2,
      title: '100% Satisfaction Guarantee',
      description: 'Your satisfaction is our priority. We stand behind our work with a service guarantee.'
    }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-20 left-10 w-96 h-96 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-sky-blue rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">Why Choose Us</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Your Trusted AC Partner
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We combine technical expertise with customer-first service to deliver exceptional HVAC solutions.
          </p>
        </div>

        {/* Reasons grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="group p-8 rounded-2xl bg-white border border-gray-200 hover:border-primary hover:shadow-xl transition-all duration-300"
            >
              <div className="mb-6 inline-flex p-4 bg-sky-blue/10 rounded-xl group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                <reason.icon className="text-primary group-hover:text-white transition-colors" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats section */}
        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center space-y-2">
            <p className="text-5xl font-bold text-primary">500+</p>
            <p className="text-gray-600 font-medium">Happy Clients</p>
          </div>
          <div className="text-center space-y-2">
            <p className="text-5xl font-bold text-primary">10+</p>
            <p className="text-gray-600 font-medium">Years Experience</p>
          </div>
          <div className="text-center space-y-2">
            <p className="text-5xl font-bold text-primary">1000+</p>
            <p className="text-gray-600 font-medium">Projects Completed</p>
          </div>
          <div className="text-center space-y-2">
            <p className="text-5xl font-bold text-primary">98%</p>
            <p className="text-gray-600 font-medium">Satisfaction Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
